<div>
  <div [formGroup]="schoolService.schoolForm" *ngIf="schoolService.schoolForm">
    <h3 class="global-title">
      Courses
    </h3>
    <div class="course-form-container">
      <div formArrayName="courses" *ngFor="let course of courseFormArray; let i = index">
        <div [formGroupName]="i" class="course-container">
          <div class="course-left-container">
            <p>
              Code
            </p>
            <div class="code-input-container">
              <input pInputText formControlName="code">
              <p-button label="X" (onClick)="deleteCourse(course, i)" [disabled]="schoolService.selectedSchool.isDeleted"></p-button>
            </div>
          </div>
          <div class="course-right-container">
            <p>
              Description
            </p>
            <div class="input-container">
              <span class="description-title">FR</span>
              <input pInputText formControlName="description" class="description-input">
            </div>
            <div class="input-container">
              <span class="description-title">EN</span>
              <input pInputText formControlName="descriptionEn" class="description-input">
            </div>
            <div class="input-container">
              <span class="description-title">NL</span>
              <input pInputText formControlName="descriptionNl" class="description-input">
            </div>
            <div class="input-container">
              <span class="description-title">ES</span>
              <input pInputText formControlName="descriptionEs" class="description-input">
            </div>
            <div class="input-container">
              <span class="description-title">PT</span>
              <input pInputText formControlName="descriptionPt" class="description-input">
            </div>
          </div>
        </div>
  
      </div>
    </div>

    <div class="add-course-button-container">
      <p-button (onClick)="addCourse()" label="Add course" [disabled]="schoolService.selectedSchool.isDeleted"></p-button>
    </div>
  </div>

</div>